/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  person: 'person',
  room: 'room',
  from: 'from',
  nights: 'nights',
  roomOnly: 'roomOnly',
  with: 'with',
  choose: 'choose',
  additionalDatesAvailable: 'additionalDatesAvailable',
  departure: 'departure',
  showMore: 'showMore',
  showLess: 'showLess',
  accommodationCategoryA: 'accommodationCategoryA',
  accommodationCategoryB: 'accommodationCategoryB',
  accommodationCategoryH: 'accommodationCategoryH'
}; export default Keys;